import {useQuery} from "@tanstack/react-query";
import FileSaver from "file-saver";
import {useEffect} from "react";
import {getEventsToCSV} from "../services/EventService";
import {formatDate} from "../util/DateUtil";
import {useLogout} from "./useLogout";

export function useEventsDownloadCsv({fromDate, toDate}, enabled = true) {
    const logout = useLogout();
    if (fromDate) {
        fromDate = formatDate(fromDate);
    }
    if (toDate) {
        toDate = formatDate(toDate);
    }
    const {data, isError, error, refetch, isFetching} = useQuery({
        queryKey: ["downloadEventsCsv", fromDate, toDate],
        queryFn: async () => {
            const response = await getEventsToCSV({fromDate, toDate});
            const blob = new Blob([response.data], {type: "text/csv;charset=utf-8;"});
            FileSaver.saveAs(blob, "MFE-Admin-Portal-Events.csv");
            return response;
        },
        enabled: enabled,
        retry: false,
    });
    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    return [refetch, isFetching, isError, error];
}
